"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var link_with_image_1 = __importDefault(require("~/components/estimate_banners/link_with_image"));
var form_with_image_1 = __importDefault(require("~/components/estimate_banners/form_with_image"));
var AfterSearchContentModal = function (props) {
    var _a = react_1.default.useState(true), open = _a[0], setIsOpen = _a[1];
    return (react_1.default.createElement(react_responsive_modal_1.default, { open: open, onClose: function () { return setIsOpen(false); } }, props.componentName === 'EstimateBannerLinkWithImage' ? react_1.default.createElement(link_with_image_1.default, __assign({}, props))
        : props.componentName === 'EstimateBannerFormWithImage' ? react_1.default.createElement(form_with_image_1.default, __assign({}, props))
            : null));
};
exports.default = AfterSearchContentModal;
